import React, { useContext, useEffect, useState } from 'react';
import Input from '../Input/Input';
import GlobalContext from '../../contexts/GlobalContext';
import { getFormattedInputValue } from '../../utils/PhoneEmailInput';
import {
  ClassName,
  Error,
  InputType,
  validateEmailRegex 
} from '../../types/PhoneEmailInput';

type PhoneEmailInputProps = {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  placeHolder: string;
  inputType?: string;
  setError?: React.Dispatch<React.SetStateAction<string>>;
  useDefualtError?: boolean;
  error?: string;
  removeErrorOnFocusProp?: Function;
  name?: string;
};

const PhoneEmailInput: React.FC<PhoneEmailInputProps> = ({
  inputValue,
  setInputValue,
  placeHolder,
  inputType,
  useDefualtError,
  removeErrorOnFocusProp,
  name
}) => {
  const { globalContext } = useContext(GlobalContext);
  const [type, setType] = useState<string>('text');
  const [error, setError] = useState<string>('');
  const [countryCodeShow, setCountryCodeShow] = useState<boolean>(false);
  const phoneCode = globalContext.i18n.getText('phone_number_code');
  const localeInfo = window && window.caastle && window.caastle.localeInfo;
  const tenant = localeInfo.countryCode.toLowerCase();
  const countryCodeClass = ClassName.CountryCode + tenant;
  const PhoneClass = ClassName.PhoneClass + tenant;

  const [inputClassValue, setInputClassValue] = useState<string>(
    ClassName.EmailClass
  );
  const handleInputValue = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    let countryCode = value.substring(0, tenant === 'uk' ? 3 : 2);
    if (countryCode === '+1' && tenant === 'us') {
      value = value.substring(countryCode.length, value.length);
    }
    if (countryCode === '+44' && tenant === 'uk') {
      value = value.substring(countryCode.length, value.length);
    }
    setCountryCodeShow(true);
    if (inputType === InputType.Phone) {
      setInputClassValue(PhoneClass);
      setType('tel');
      setCountryCodeShow(true);
      let CheckValue = value.replace(/[ \-()]+/g, '');
      if (CheckValue.length > 10) {
        CheckValue = CheckValue.slice(0, 10);
      }
      if (/^[0-9]+$/.test(CheckValue) && CheckValue.length < 10) {
        setError(Error.InvalidPhoneNumber);
      } else {
        setError('');
      }
      const formattedInputValue = getFormattedInputValue(value);
      setInputValue(formattedInputValue);
    }
    if (inputType === InputType.Email) {
      setInputClassValue(ClassName.EmailClass);
      setCountryCodeShow(false);
      setType('text');
      const newValue = value.replace(/[ \-()]+/g, '');
      if (value.length === 0) {
        setInputValue('');
      } else {
        setInputValue(newValue);
      }
      if (!validateEmailRegex.test(value)) {
        const hasLetters = /[a-zA-Z]/.test(value);
        if (hasLetters) {
          setError(Error.InvalidEmail);
        }
      } else {
        setError('');
      }
    }
    if (inputType === InputType.EmailPhone) {
      const CheckValue = value.replace(/[ \-()]+/g, '');
      setCountryCodeShow(true);
      if (value.length === 0) setError('');
      if (/^[0-9]+$/.test(CheckValue) && CheckValue.length <= 10) {
        setInputClassValue(PhoneClass);
        setError('');
        setType('tel');
        const formattedInputValue = getFormattedInputValue(value);
        setInputValue(formattedInputValue);
      } else {
        setType('text');
        setCountryCodeShow(false);
        setInputClassValue(ClassName.EmailClass);
        const newValue = value.replace(/[ \-()]+/g, '');
        if (value.length === 0) {
          setInputValue('');
        } else {
          setInputValue(newValue);
        }
        if (!(validateEmailRegex.test(value))) {
          const hasLetters = /[a-zA-Z]/.test(value);
          const hasNumbers = /\d/.test(value);
          setCountryCodeShow(false);
          if (hasLetters && hasNumbers) {
            setError(Error.InvalidInput);
          } else if (hasLetters) {
            setError(Error.InvalidEmail);
          } else if (hasNumbers) {
            setError(Error.InvalidPhoneNumber);
          }
          if (value.length !== 0) {
            setCountryCodeShow(false);
          }
        } else {
          setError('');
        }
      }
    }
  };

  const removeErrorOnFocus = () => {
    if (typeof removeErrorOnFocusProp === 'function') {
      removeErrorOnFocusProp(name || '');
    } else {
      setError('');
    }
  };

  useEffect(() => {
    if (inputType === InputType.Phone) {
      setCountryCodeShow(true);
      setInputClassValue(PhoneClass);
    }
  }, []);

  return (
    <div>
      <div className="regulatory-updates-modal__info">
        <Input
          type={type}
          placeholder={placeHolder}
          value={inputValue}
          onChange={handleInputValue}
          className={inputClassValue}
          onFocus={removeErrorOnFocus}
        />

        {countryCodeShow && (
          <div id="dnss-phone-code">
            <div
              className={
                'regulatory-updates__input-flag ' + countryCodeClass
              }></div>
            <div className="regulatory-updates__input-code">+{phoneCode}</div>
          </div>
        )}
      </div>
      {useDefualtError && <span className="real-time-error">{error}</span>}
    </div>
  );
};
export default PhoneEmailInput;
